import * as searchModule from "@buildwithflux/search";
import * as urlModule from "@buildwithflux/url";

export interface SitemapSubcategoryMatch {
    categoryKey: string;
    subcategoryKey: string;
}

function packageExports<T extends object>(packageModule: T): T {
    return "default" in packageModule ? (packageModule.default as T) : packageModule;
}

const {SitemapContent} = packageExports(searchModule);
const {Routes} = packageExports(urlModule);

function normalizeQuery(value: string): string {
    return value.trim().toLowerCase().replace(/\s+/g, " ");
}

export function findSitemapSubcategoryForSearch(
    query: string,
    searchIndex: string,
): SitemapSubcategoryMatch | undefined {
    const normalizedQuery = normalizeQuery(query);
    if (!normalizedQuery) return undefined;

    for (const category of Object.values(SitemapContent)) {
        for (const subcategory of Object.values(category.subcategories)) {
            const normalizedSubcategoryQuery = normalizeQuery(subcategory.query);
            if (
                normalizedSubcategoryQuery &&
                normalizedSubcategoryQuery === normalizedQuery &&
                subcategory.searchIndex.toLowerCase() === searchIndex.toLowerCase()
            ) {
                return {categoryKey: category.key, subcategoryKey: subcategory.key};
            }
        }
    }
    return undefined;
}

export function getSearchResultsIndexing(
    query: string,
    queryType: string,
    pageNum: number,
): {canonicalPath: string; noindex: boolean} {
    const match = pageNum <= 1 ? findSitemapSubcategoryForSearch(query, queryType) : undefined;
    if (match) {
        return {
            canonicalPath: Routes.SITEMAP_SUBCATEGORY.replace(":category", match.categoryKey).replace(
                ":subcategory",
                match.subcategoryKey,
            ),
            noindex: false,
        };
    }

    return {
        canonicalPath: `/search?q=${encodeURIComponent(query)}&type=${queryType}`,
        noindex: true,
    };
}
